const DataTableFooter = ({
  currentPage,
  totalPages,
  setCurrentPage,
  totalEntries,
  pageSize,
}) => {
  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      <div>
        Showing {(currentPage - 1) * pageSize + 1} to{" "}
        {Math.min(currentPage * pageSize, totalEntries)} of {totalEntries}{" "}
        entries
      </div>
      <div className="dataTables_paginate paging_simple_numbers">
        <ul className="pagination">
          <li
            className={`paginate_button page-item previous ${
              currentPage === 1 ? "disabled" : ""
            }`}
          >
            <button className="page-link" onClick={handlePrev}>
              Previous
            </button>
          </li>
          {[...Array(totalPages)].map((_, i) => (
            <li
              key={i}
              className={`paginate_button page-item ${
                currentPage === i + 1 ? "active" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            </li>
          ))}
          <li
            className={`paginate_button page-item next ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button className="page-link" onClick={handleNext}>
              Next
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default DataTableFooter;
